<script setup lang="ts">
defineProps({ blok: Object });

const { state } = useAppStore();

const charts = ref<any[]>([]);

const activeChart = ref(0);
const activeEvolutionChart = ref(0);
const participantSelected = ref<string | null>(null);

const { data: evolutionData } = await useFetch<any>(`/api/data/company/history`);

onMounted(async () => {
  await $fetch<any>(`/api/data/company`).then((res) => {
    console.log(res);
    res.map((companyType: any) => {
      console.log(companyType);
      const ct = () => {
        const sortedCompanies = companyType.companies.sort((a: any, b: any) => {
          return b.scores[8].over_100 - a.scores[8].over_100;
        });

        return {
          name: companyType.company_type,
          companies: sortedCompanies.map((company: any) => {
            return company.name;
          }),
          data: sortedCompanies.map((company: any) => {
            return company.scores[8].over_100;
          }),
        };
      };
      charts.value.push(ct());
    });
  });
});

const getColor = (colorKey: string) => {
  if (colorKey == "Red") {
    return "#F18686";
  }
  if (colorKey == "Yellow") {
    return "#FFD867";
  }
  if (colorKey == "Orange") {
    return "#E89903";
  }
  if (colorKey == "Green") {
    return "#79DD7D";
  }
  return "#D9D9D9";
};

const getYearEdition = (year: number) => {
  if (year == 2026) {
    return "7th";
  }
  if (year == 2025) {
    return "6th";
  }
  if (year == 2024) {
    return "5th";
  }
  if (year == 2023) {
    return "4th";
  }
};

const onCompanyHover = (id: string | null) => {
  participantSelected.value = id;
};
</script>

<template>
  <section class="section relative">
    <div
      class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]"
    />
    <!-- <UiContainer max-width="max-w-3xl">
      <header class="global-header global-header--center">
        <StoryblokRichText :doc="blok?.header" />
      </header>
    </UiContainer> -->
    <!-- <HomeRanks :blok="blok?.HomeCompaniesRanks" /> -->
    <UiContainer max-width="max-w-3xl" class="mt-20">
      <header class="global-header global-header--center">
        <StoryblokRichText :doc="blok?.comparative_header" />
      </header>
    </UiContainer>
    <UiContainer>
      <div>
        <div class="flex items-center justify-center gap-2 mb-6 max-[769px]:flex-col">
          <div v-for="(chart, index) in charts" :key="chart.name">
            <UButton
              v-if="chart.name == 'Big Companies'"
              :label="useCompanySizeName(state.sizes, 2)"
              :variant="activeChart === index ? 'solid' : 'outline'"
              @click="activeChart = index"
            />
            <UButton
              v-if="chart.name == 'Small Companies'"
              :label="useCompanySizeName(state.sizes, 1)"
              :variant="activeChart === index ? 'solid' : 'outline'"
              @click="activeChart = index"
            />
            <UButton
              v-if="chart.name == 'Retailers'"
              :label="useCompanySizeName(state.sizes, 3)"
              :variant="activeChart === index ? 'solid' : 'outline'"
              @click="activeChart = index"
            />
          </div>
        </div>
        <ClientOnly>
          <div v-if="charts.length">
            <div v-for="(chart, index) in charts" :key="chart.name">
              <apex-charts
                v-if="activeChart === index"
                width="100%"
                height="600"
                :options="{
                  chart: {
                    type: 'bar',
                    stackType: '100%',
                    toolbar: {
                      show: false,
                    },
                  },
                  stroke: {
                    show: false,
                  },
                  legend: {
                    show: false,
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val: number) {
                      return val.toFixed(0) + '%';
                    },
                    offsetY: -20,
                    style: {
                      fontSize: '12px',
                      colors: ['#304758'],
                    },
                  },
                  colors: [
                    function ({ value }: any) {
                      return useScoreTreshold(value).default;
                    },
                  ],
                  tooltip: {
                    enabled: false,
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 0,
                      dataLabels: {
                        position: 'top', // top, center, bottom
                      },
                    },
                  },
                  xaxis: {
                    categories: chart.companies,
                  },
                }"
                :series="[
                  {
                    name: 'Overall',
                    data: chart.data,
                  },
                ]"
              />
            </div>
          </div>
          <div v-else>
            <UProgress animated indeterminate />
          </div>
        </ClientOnly>
      </div>
    </UiContainer>
    <UiContainer max-width="max-w-3xl" class="mt-20 max-[769px]:hidden">
      <header class="global-header global-header--center">
        <h4 class="text-chsc-indigo-500 fs-6xl font-londrina-solid">
          {{ blok?.evolution_header }}
        </h4>
      </header>
    </UiContainer>
    <UiContainer class="max-[769px]:hidden">
      <div class="-mt-10 flex items-center justify-center gap-2 mb-6 max-[769px]:flex-col">
        <div v-for="(chart, index) in charts" :key="chart.name">
          <UButton
            v-if="chart.name == 'Big Companies'"
            :label="useCompanySizeName(state.sizes, 2)"
            :variant="activeEvolutionChart === index ? 'solid' : 'outline'"
            @click="activeEvolutionChart = index"
          />
          <UButton
            v-if="chart.name == 'Small Companies'"
            :label="useCompanySizeName(state.sizes, 1)"
            :variant="activeEvolutionChart === index ? 'solid' : 'outline'"
            @click="activeEvolutionChart = index"
          />
          <UButton
            v-if="chart.name == 'Retailers'"
            :label="useCompanySizeName(state.sizes, 3)"
            :variant="activeEvolutionChart === index ? 'solid' : 'outline'"
            @click="activeEvolutionChart = index"
          />
        </div>
      </div>
      <div class="mt-10 max-[769px]:hidden">
        <div class="">
          <div
            v-for="edition in evolutionData"
            :key="edition.year"
            cass="relative flex items-center"
          >
            <template v-for="(company, index) in edition.companies" :key="company.id">
              <div v-if="activeEvolutionChart === index" class="flex mb-6">
                <p class="mr-4 font-londrina-solid fs-3xl text-chsc-indigo-500 uppercase">
                  {{ getYearEdition(edition.year) }}
                </p>
                <template
                  v-for="(rank, rankIndex) in company.ranking.sort(
                    (a: any, b: any) => b.position - a.position,
                  )"
                  :key="rank.id"
                >
                  <div
                    :class="[
                      'group relative min-w-[36px] min-h-[36px] rounded-full flex items-center justify-center fs-xs border border-white hover:z-1 max-[1025px]:min-w-[30px] max-[1025px]:min-h-[30px]',
                      { 'opacity-60': participantSelected !== rank.id },
                      { 'opacity-100': participantSelected === rank.id },
                    ]"
                    :style="{
                      backgroundColor: getColor(rank.color),
                      right: `${rankIndex * 7}px`,
                    }"
                    @mouseover="onCompanyHover(rank.id)"
                    @mouseleave="onCompanyHover(null)"
                  >
                    <span
                      :class="[
                        { 'opacity-0': participantSelected !== rank.id },
                        { 'opacity-100': participantSelected === rank.id },
                        'group-hover:opacity-100 transition-opacity duration-300',
                      ]"
                      >{{ rank.position }}</span
                    >
                    <div
                      class="absolute top-2/3 left-2/3 w-[150px] group-hover:opacity-100 transition-opacity duration-300 bg-chsc-raw p-2.5 opacity-0 rounded-sm pointer-events-none"
                    >
                      <p>{{ rank.name }}</p>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
